import { useState, useEffect } from "react";
import { useLazyQuery } from "react-apollo";

import {
  SINGLE_BOOKING_CODE_QUERY,
  ALL_BOOKING_CODES_QUERY
} from "../graphql/BookingCodes/BookingCodes.graphql";
import { SINGLE_SYSTEM_CODE_QUERY } from "../graphql/SystemCodes/SystemCodes.graphql";

function useBookingCodeReversible(bookingCodeRecIdRef) {
  console.log({ bookingCodeRecIdRef });
  const [isReversible, setIsReversible] = useState(false);

  const [getBookingCode, { data: GetBookingCodeData }] = useLazyQuery(
    SINGLE_BOOKING_CODE_QUERY
  );
  const [
    getReverseBookingCode,
    { data: GetReverseBookingCodeData }
  ] = useLazyQuery(ALL_BOOKING_CODES_QUERY);

  const [
    getBookingCodeCategory,
    { data: GetBookingCodeCategoryData }
  ] = useLazyQuery(SINGLE_SYSTEM_CODE_QUERY);

  useEffect(() => {
    if (bookingCodeRecIdRef) {
      getBookingCode({
        variables: { where: { RecId: parseInt(bookingCodeRecIdRef, 10) } }
      });
    }
  }, [bookingCodeRecIdRef, getBookingCode]);

  useEffect(() => {
    const bookingCode = GetBookingCodeData?.BookingCode;
    if (bookingCode?.BookingCode) {
      getReverseBookingCode({
        variables: { where: { BookingCode: `${bookingCode.BookingCode}-R` } }
      });
    }
  }, [GetBookingCodeData, getReverseBookingCode]);

  useEffect(() => {
    const bookingCode = GetBookingCodeData?.BookingCode;
    if (bookingCode?.CodeCatgRecIdRef) {
      getBookingCodeCategory({
        variables: {
          where: { RecId: parseInt(bookingCode.CodeCatgRecIdRef, 10) }
        }
      });
    }
  }, [GetBookingCodeData, getBookingCodeCategory]);

  useEffect(() => {
    const bookingCode = GetBookingCodeData?.BookingCode;
    const sysCode = GetBookingCodeCategoryData?.SystemCode;
    setIsReversible(
      !bookingCode?.BookingCode?.includes("-R") &&
        sysCode &&
        sysCode?.CodeId === "NA-PTO"
    );
  }, [GetBookingCodeCategoryData, GetBookingCodeData]);

  console.log(GetReverseBookingCodeData);

  return [isReversible, GetReverseBookingCodeData?.BookingCodes?.[0]?.RecId];
}

export default useBookingCodeReversible;
